<template>
    <modal-dialog
        id="project-logs-dialog"
        :show.sync="shown"
    >
        <template v-slot:title>
            {{ title }}
        </template>

        <loader v-if="loading" />
        <ul v-else-if="logs.length" class="uk-list uk-list-line">
            <li
                v-for="log in logs"
                :key="log.id"
            >
                <span
                    v-if="log.automated"
                    class="uk-text-muted uk-text-uppercase"
                >
                    {{ log.description }}
                </span>
                <div v-else v-html="log.description" v-linkified class="lam-log-text"></div>
                <div class="uk-text-muted">
                    <small>
                        <open-icon glyph="clock-o" /> {{ log.executed_at | nibnut.date_from_now("MMMM DD, YYYY @ hh:mm a") }}, by {{ log.initials }}
                    </small>
                </div>
            </li>
        </ul>

        <div class="uk-modal-footer uk-text-center">
            <base-button size="large" :block="true" @click.native.prevent="close">Done</base-button>
        </div>
    </modal-dialog>
</template>

<script type="text/javascript">
import { orderBy } from "lodash"

import ModalDialog from "./ModalDialog/ModalDialog"
import BaseButton from "../ui/BaseButton"
import OpenIcon from "../ui/OpenIcon"
import Loader from "../ui/Loader"

import linkify from "vue-linkify"

export default {
    components: {
        ModalDialog,
        BaseButton,
        OpenIcon,
        Loader
    },
    directives: {
        linkified: linkify
    },
    mounted () {
        this.load()
    },
    watch: {
        show: "load",
        "project.id": "load"
    },
    methods: {
        load () {
            if(this.show) {
                this.loading = true
                this.$store.dispatch(
                    "FETCH_RECORDS",
                    {
                        entity: "project_log",
                        query: {
                            project_id: this.project.id
                        }
                    }
                ).then(response => {
                    this.record_ids = response.record_ids
                }).catch(error => {
                    this.$error(error.message)
                }).then(() => {
                    this.loading = false
                })
            }
        },
        close () {
            this.$emit("update:show", false)
        }
    },
    computed: {
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        },
        title () {
            if(this.project) return this.project.name
            return ""
        },
        logs () {
            return orderBy(
                this.$store.getters.entity_records("project_log", this.record_ids),
                "executed_at",
                "desc"
            )
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        project: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            loading: false,
            record_ids: []
        }
    }
}
</script>
